import React, { useState } from "react";
import { Alert, Button, Form, Container, Row, Col } from "react-bootstrap";
import { authenticate } from "../services/authenticate";
import { useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import NavBar from "../Header/NavBar";

const Login = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState({
    emailErr: "",
    passwordErr: "",
    loginErr: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    let emailErr = "";
    let passwordErr = "";

    if (formData.email === "") {
      emailErr = "Email is required";
    }
    if (formData.password === "") {
      passwordErr = "Password is required";
    }

    if (emailErr || passwordErr) {
      setError({ ...error, emailErr, passwordErr });
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError({ emailErr: "", passwordErr: "", loginErr: "" });
    if (validateForm()) {
      authenticate(formData.email, formData.password)
        .then((data) => {
          setError({ ...error, loginErr: "" });
          const path = sessionStorage.getItem("intendedPage");
          if (path) {
            sessionStorage.removeItem("intendedPage");
            navigate(path);
          } else {
            navigate("/stockSearch");
          }
        })
        .catch((err) => {
          setError({ ...error, loginErr: err.message });
        });
    }
  };

  return (
    <>
      <div>
        <Header />
      </div>
      <div style={{ marginTop: "40px" }}>
        <NavBar />
      </div>
      <Container className="mt-5">
        <h2 className="text-center mb-4">Login</h2>
        <Row className="justify-content-md-center">
          <Col md={4}>
            {error.loginErr && <Alert variant="danger">{error.loginErr}</Alert>}
            <Form className="w-50" onSubmit={handleSubmit}>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  name="email" // Added name attribute
                  value={formData.email} // Corrected value
                  onChange={handleChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {error.emailErr}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId="formBasicPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Password"
                  name="password" // Added name attribute
                  value={formData.password} // Corrected value
                  onChange={handleChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {error.passwordErr}
                </Form.Control.Feedback>
              </Form.Group>

              <Button variant="primary" type="submit" className="w-50 mt-3">
                Login
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Login;
